import angular from 'angular';
import bulkDetailsModalComponent from './bulk.details.modal.component';
export default angular.module('inv.customer.orderHistory.bulkDetailsModal', []).component('bulkDetailsModal', bulkDetailsModalComponent).name;